<style lang="scss" scoped>
.img {
  height: 100%;
  width: 100%;
  object-fit: contain;
}

.pay-item-comp {
  .type-item {
    height: 60 * 2px;
    display: flex;
    align-items: center;
    box-shadow: inset 0px -1px 0px #F1F1F6;
    .icon {
      width: 32 * 2px;
      height: 32 * 2px;
      margin-right: 16 * 2px;
    }
    .name {
      flex: 1;
      color: #2a2a30;
      font-size: 14 * 2px;
      line-height: 20 * 2px;
    }
    .select {
      margin-right: 22 * 2px;
      width: 24 * 2px;
      height: 24 * 2px;
    }
  }
}

</style>

<template>
<div class="pay-item-comp">
  <!-- 支付方式选择区域 -->
  <div class="type-item" @click="changeType">
    <div class="icon">
      <img :src="payConfig.icon" class="img" />
    </div>
    <div class="name">
      {{payConfig.name}}
    </div>
    <div class="select">
      <img v-if="curSelect === payConfig.type" src="https://oss.turingsenseai.com/1630484553408507777.png">
      <img v-else src="https://oss.turingsenseai.com/1630484602564666030.png">
    </div>
  </div>
</div>
</template>

<script>

/**
 * payCofig的格式应该如下，请正确填写
 * payConfig {
 *  icon: '', // 支付图标示例
 *  name: '', // 支付方式名称
 *  type: '', // 支付方式协定字段
 *  selected: '', // 设置默认选中，自定义时设置，请勿设置多个默认选中
 * }
 */

export default {
  props: {
    payConfig: {
      default: () => {}
    },
    defaultType: {
      default: () => 'wxpay'
    },
    curSelect: {
      default: () => 'wxpay'
    },
  },
  data() {
    return {
      payType: 'wxpay',
      selected: true,
      showWxPay: true,
      showAliPay: true,
    }
  },
  created () {

  },
  methods: {
    changeType() {
      this.$emit('change-type', this.payConfig.type)
    }
  }
}
</script>
